import * as api from '../../services/location/apiLocation';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { MASS_CREATE_ITEMS } from '../../components/admin/location/modals/MassItemLocationModalConstants';
import { change } from 'redux-form';
import { 
  processingMassCreateItem, 
  doneProcessingMassCreateItem,
  showMessageModal
} from '../../components/admin/location/modals/MassItemLocationModalActions';
import { LocationForm } from "../../constants/constant_form_names";

export function* deleteLocationSaga(feathersApp) {
  yield takeEvery('DELETE_LOCATION', callDeleteLocation, feathersApp);
}

export function* deleteLocationFromListSaga(feathersApp) {
  yield takeEvery('DELETE_LOCATION_FROM_LIST', callDeleteLocationFromList, feathersApp);
}

export function* fetchListLocationSaga(feathersApp) {
  yield takeLatest('FETCH_LIST_LOCATION', callFetchListLocation, feathersApp);
}

export function* fetchLocationForEditSaga(feathersApp) {
  yield takeEvery('FETCH_LOCATION_FOR_EDIT', callFetchLocationForEdit, feathersApp);
}

export function* saveLocationSaga(feathersApp) {
  yield takeEvery("SAVE_LOCATION", callSaveLocation, feathersApp);
}

export function* massCreateItemsSaga(feathersApp){
  yield takeEvery( MASS_CREATE_ITEMS, callMassCreateItems, feathersApp);

}


function* callFetchListLocation(feathersApp, action) {
  const { silent, filters } = action;  
  yield common.showProgressListTable(silent);
  try {
    const dataParams = { 
      filters, 
      list_type: 'location'
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

function* callDeleteLocationFromList(feathersApp, action) {
  yield deleteLocation(feathersApp, action);
  yield delay(2000); 
  yield callFetchListLocation(feathersApp, { silent: true });
}

function* callDeleteLocation(feathersApp, action) {
  const result = yield deleteLocation(feathersApp, action);
  yield delay(2000); 
  if (result) {
    browserHistory.push('/admin/location');
  }
}

function* deleteLocation(feathersApp, action) {
  yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  try {
    const { id } = action;
    let result = null;
    if (id) {
      const { tenant, user } = yield select();
      const { id } = action;
      const params = { tenant, user, id };
      result = yield call(api.deleteLocation, feathersApp, params);
      yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.LOCATION } });
    }
    return result;
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error });
  }
}



function* callSaveLocation(feathersApp, action) {
  const { tenant, user, silent } = yield select();
  let data = { ...action.data };
  if (data) {
    try {
      yield common.showProgressSaveRecord(silent);
      const result = yield call(api.saveLocation, feathersApp, {tenant, user, data: data });
      yield delay(2000);
      yield call(callFetchLocationForEdit, feathersApp, { id: result.id, silent: true });
      browserHistory.push(`/admin/location/edit/${result.id}`);
      yield common.doneSaveRecord(result, 'Location was saved');
    } catch (error) {
      console.log({ error });
      yield common.showErrorSaveRecord(error);
    }
  }
}

function* callFetchLocationForEdit(feathersApp, action) {
  const { tenant, user, path } = yield select();
  const { id, silent } = action;
  try {
    let data;

    if (id) {
      yield common.showProgressDataById(silent);
      const fetchParams = { tenant, user, id, path };
      const doc = yield call(api.fetchLocationById, feathersApp, fetchParams);
      const subLocationList = yield call(api.fetchSubLocationsByParentId, feathersApp, fetchParams);
      if (subLocationList.data.length > 0) {
        doc.sub_locations = subLocationList.data;
      } else {
        doc.sub_locations = [];
      }
      doc.hasItemLocations = yield call(locationHasItemLocations, feathersApp, id);

      data = doc;
    } else {
      const initialValues = {
        active: true,
        location_type_id: 'store',
        return_mapped_location_type: 'hold',
        layby_mapped_location_type: 'hold',
        deposit_mapped_location_type: 'hold',
        disposal_mapped_location_type: 'hold',
        shipping_mapped_location_type: 'hold',
        pickup_mapped_location_type: 'hold',
        preorder_mapped_location_type: 'hold',
        reserved_mapped_location_type: 'hold',
      };

      data = initialValues;
    }

    yield common.doneDataById(data);
  } catch (error) {
    console.error(error.stack);
    yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
  }
}


/**
 * Check if location has existing item 
 * @param {*} feathersApp 
 * @param {*} id 
 */
function* locationHasItemLocations(feathersApp, id){
  const dataParams = {
    location_id: id
  };

  const count = yield call(apiCommon.queryDocs, feathersApp, 'item_location/count', dataParams);
  return Boolean(count);
}


function* callMassCreateItems(feathersApp, action){
  try {
    const { data } = action;
    const { target_location } = data;
    yield put(processingMassCreateItem());
    yield put(showMessageModal());
    const result = yield call(api.generateItemLocation, feathersApp, data);
    yield put(doneProcessingMassCreateItem(result.total_processed));
    const hasItemLocations = yield call(locationHasItemLocations, feathersApp, target_location);
    yield put(change(LocationForm, "hasItemLocations", hasItemLocations));
  } catch(e){
    console.error(e.stack);
    yield put(doneProcessingMassCreateItem(0));
    common.showErrorSaveRecord(e);
  }
}
